import type { Country } from 'src/types/country'
import getFormattedPhone from 'src/functions/formatPhone/functions/getFormattedPhone'
import getPhoneData from 'src/functions/formatPhone/functions/getPhoneData'
import getRawPhone from 'src/functions/formatPhone/functions/getRawPhone'

export default function formatPhone({
  phone,
  country,
  isRaw,
  normalizePhoneCode,
}: {
  phone: any
  country?: Country
  isRaw?: boolean
  normalizePhoneCode?: boolean
}) {
  if (
    (typeof phone !== 'string' && typeof phone !== 'number')
    || (typeof phone === 'number' && !/^\d+$/.test(String(phone)))
  ) {
    return phone
  }

  const phoneData = getPhoneData(country, normalizePhoneCode)

  return isRaw
    ? getRawPhone(String(phone), phoneData)
    : getFormattedPhone(String(phone), phoneData)
}
